import {
  Button,
  COMPANY_NAME,
  isMobileAtom,
  JEJURO,
  NAME_REGEX,
  PAGE_NAME,
  PHONE_NUMBER_REGEX,
  saveGuestLookup,
  Styles,
  TextInputV2,
  useRecoil,
} from '@orcar/common-d2c';
import { Dispatch, SetStateAction, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';

const FindReservationPage = () => {
  const navigate = useNavigate();

  const [userName, setUserName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const { recoilValue: isMobile } = useRecoil(isMobileAtom);

  const handlePhoneNumber: Dispatch<SetStateAction<string>> = (value) => {
    value = value.toString().replaceAll('-', '');

    if (value.length > 11) return;
    setPhoneNumber(value);
  };

  const handleOrderConfirmation = () => {
    saveGuestLookup({
      customerName: userName,
      customerPhoneNumber: phoneNumber,
    });
    navigate(PAGE_NAME.my_page);
  };
  return (
    <OuterWrapper isMobile={isMobile}>
      <InnerWrapper isMobile={isMobile}>
        <Title isMobile={isMobile}>{COMPANY_NAME[JEJURO]} 예약 조회</Title>
        <InfoText isMobile={isMobile}>
          상품 구매를 위해 사용했던 고객 정보를 입력해주세요.
        </InfoText>
        <InfoText isMobile={isMobile}>
          예약할 때 등록한 정보와 일치해야 예약 조회가 가능합니다.
        </InfoText>
        <WidthWrapper isMobile={isMobile}>
          <TextInputV2
            label='예약자명'
            placeholder=''
            explanation='예약할 때 등록한 이름으로 입력해주세요.'
            value={userName}
            setValue={setUserName}
            pattern={NAME_REGEX}
            type='text'
            autoFocus
          />
          <TextInputV2
            type='tel'
            label='휴대전화'
            placeholder=''
            explanation='-빼고 숫자만 입력해주세요.'
            value={phoneNumber}
            setValue={handlePhoneNumber}
            pattern={PHONE_NUMBER_REGEX}
          />
          <ButtonWrapper isMobile={isMobile}>
            <Button
              onClick={handleOrderConfirmation}
              disabled={!userName || phoneNumber.length < 11}
              font={Styles.FONT.H4}
              borderRadius='5px'
              width='100%'
              height='59px'
            >
              {/* 로그인 */}
              예약 조회
            </Button>
          </ButtonWrapper>
        </WidthWrapper>
      </InnerWrapper>
    </OuterWrapper>
  );
};

const OuterWrapper = styled.div<{ isMobile: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px 0 50px;

  ${({ isMobile, theme }) =>
    isMobile &&
    css`
      height: calc(100vh - 67px); // mobile header height만큼 빼주기
      padding-top: 32px;
      margin: 0;
      background-color: ${theme.COLOR.GREY_BG};
    `}
`;

const Title = styled.h4<{ isMobile: boolean }>`
  ${({ isMobile, theme }) =>
    isMobile ? theme.NEW_FONT.H4 : theme.NEW_FONT.H2};
  color: ${({ theme }) => theme.COLOR.GREY_01};
  margin: ${({ isMobile }) => (isMobile ? '0 0 16px' : '0 0 30px 0')};
  text-align: center;
`;

const InnerWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 40px;

  ${({ isMobile }) =>
    isMobile &&
    css`
      width: 100%;
      padding: 0 20px;
    `}
`;

const InfoText = styled.span<{ isMobile: boolean }>`
  width: ${({ isMobile }) => isMobile && '176px'};
  ${({ isMobile, theme }) => (isMobile ? theme.FONT.B3 : theme.FONT.B1)};
  color: ${({ theme }) => theme.COLOR.GREY_02};
  margin-bottom: ${({ isMobile }) => (isMobile ? '6px' : '6px')};
  text-align: center;
`;

const WidthWrapper = styled.div<{ isMobile: boolean }>`
  margin-top: 30px;
  width: ${({ isMobile }) => (isMobile ? '100%' : '384px')};
`;

const ButtonWrapper = styled.div<{ isMobile: boolean }>`
  width: 100%;
  margin-top: 66px;

  ${({ isMobile }) =>
    isMobile &&
    css`
      position: fixed;
      bottom: 20px;
      left: 0;
      padding: 0 20px;
      margin-top: 0;
    `}
`;

export default FindReservationPage;
